import { IListApiRequest, IListApiResponse } from 'api/types'

export enum Status {
  Accepted = 'Accepted',
  Pending = 'Pending',
  Rejected = 'Rejected'
}

export interface Document {
  id: number;
  status: Status;
  description?: string | null;
  documentNo?: any;
  imageUrls?: string;
  documentType?: string;
}

export type Documents = Document[]

export interface Company {
  id: number;
  name: string;
  websiteUrl?: string | null;
  email?: string | null;
  phoneNo?: string | null;
  approved?: boolean | null;
  subsId: number;
  addressLine1?: string | null;
  addressLine2?: string | null;
  active: boolean;
  createdBy?: string | null;
  createdDate?: string | null;
  lastModifiedBy?: string | null;
  lastModifiedDate?: string | null;
  documents: Document[];
}
export type comapnySaveRequest = {
  ComapnyDTO: Company
}
export type CompanyListRequest = IListApiRequest<Company>
export type CompanyListResponse = IListApiResponse<Company> & {
  documents: Document
}
